export default __webpack_public_path__ + "static/media/text-field-sizes.edd4bb94.svg";